import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import {
  useGetOrganizationsQuery,
  useDeleteOrganizationMutation,
} from '../../api/organizationApi';
import { useToast } from '../../context/ToastContext';
import { errMsg } from '../../utils/errMsg';
import s from '../../styles/shared/page.module.css';
import buttons from '../../styles/shared/buttons.module.css';
import table from '../../styles/shared/table.module.css';

export default function OrganizationsPage() {
  const { data: organizations, isLoading, isError, error } =
    useGetOrganizationsQuery();
  const [deleteOrganization] = useDeleteOrganizationMutation();
  const navigate = useNavigate();
  const showToast = useToast();

  useEffect(() => {
    if (isError) {
      showToast('error', 'Organizations', errMsg(error, 'Could not load organizations.'));
    }
  }, [isError, error, showToast]);

  const goEdit = (organization) => navigate(`${organization.id}/edit`);

  async function handleDelete(organization) {
    try {
      await deleteOrganization(organization.id).unwrap();
      showToast('success', 'Organizations', 'Organization deleted.');
    } catch (err) {
      showToast('error', 'Organizations', errMsg(err, 'Could not delete organization.'));
    }
  }

  const actionBodyTemplate = (organization) => (
    <div className={table.actions}>
      <Button
        icon="pi pi-pencil"
        text
        className={table.iconNeutral}
        onClick={() => goEdit(organization)}
      />
      <Button
        icon="pi pi-trash"
        text
        className={table.iconDanger}
        onClick={() => handleDelete(organization)}
      />
    </div>
  );

  return (
    <div className={s.page}>
      <div className={s.header}>
        <div>
          <h1>Organizations</h1>
        </div>
        <Button
          label="Add organization"
          icon="pi pi-plus"
          className={buttons.btnPrimary}
          onClick={() => navigate('create')}
        />
      </div>

      <div className={table.tableWrapper}>
        <DataTable
          value={organizations ?? []}
          loading={isLoading}
          emptyMessage="No organizations yet. Add one above."
          responsiveLayout="stack"
        >
          <Column
            field="name"
            header="Name"
            className={table.contactCol}
            body={(o) => <div className={table.cellInsider}>{o.name}</div>}
          />
          <Column
            field="slug"
            header="Slug"
            className={`${s.mutedCell} ${table.contactCol}`}
            body={(o) => <div className={table.cellInsider}>{o.slug}</div>}
          />
          <Column
            header="Actions"
            className={table.actionsCol}
            body={actionBodyTemplate}
            style={{ width: '172px' }}
          />
        </DataTable>
      </div>
    </div>
  );
}
